/**
 * 135编辑器
 * 2018-4-17
 * Bai.Zhiming
 */
'use strict';
angular.module('135editorModule', ['135editorDemoModule', 'setting135EditorModule']).directive('editor135', [
    '$q',
    'ueditorForAppService',
    '$interval',
    'ueditorForAppBtnService',
    'ueditorService',
    '$timeout',
    'ueditorPlugIn',
    'thirdPartyPlugins',
    function($q, ueditorForAppService, $interval, ueditorForAppBtnService, ueditorService, $timeout, ueditorPlugIn, thirdPartyPlugins) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                list: '=',
                type: '@',
                versionid: '=',
                newFeatures: '=', // app编辑器新增功能
                setFont: '=',
                hasContent: '=',
                compareVersion: '@', // 初始化时是否进行版本比对
            },
            template: '<div class="editorContainer135"><script id="ueditor" type="text/plain" style="position:relative;width:100%"></script></div>',
            link: function(scope, $element, $attrs) {
                var ue;
                var domUtils;
                var ueditorBtn;
                scope.newFeatures = (function() {
                    // app新增功能数据转换
                    if (angular.isObject(scope.newFeatures)) {
                        return scope.newFeatures;
                    }
                    var array = scope.newFeatures.split(',');
                    var obj = {};
                    for (var i = 0; i < array.length; i++) {
                        obj[array[i]] = true;
                    }
                    return obj;
                })();
                $q.all([
                    thirdPartyPlugins.get135plugins(scope.newFeatures['135插件'] === true),
                    thirdPartyPlugins.getXiumiPlugins(scope.newFeatures['秀米插件'] === true),
                ]).then(function() {
                    initStatus();
                    initData();
                });

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {};
                    scope.data = {};
                    initEditor().then(function() {});
                    initDestroy();
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {}

                /**
                 * [getEditor description] 获取编辑器实例
                 * @return {[type]} [description]
                 */
                function initEditor() {
                    var deffer = $q.defer();
                    $timeout(function() {
                        var indexArray = scope.setFont.fontFamilyCustom ? [8, 33, 41] : [8, 9, 10, 28, 33, 41];
                        var editorToolBar = ueditorService.getToolBar();
                        editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
                        // ue.execCommand("lineheight", scope.setFont.lineSpacing); //设置行距
                        if (!scope.setFont.fontFamilyCustom) {
                            editorToolBar.initialStyle =
                                'p{line-height:' +
                                scope.setFont.lineSpacing +
                                'em;font-size:' +
                                scope.setFont.fontSize +
                                ';font-family:' +
                                scope.setFont.fontType +
                                '}';
                        } else {
                            editorToolBar.initialStyle = 'p{line-height:' + scope.setFont.lineSpacing + 'em;}';
                        }
                        var isHttps = window.location.href.indexOf('https://') >= 0 ? 'https' : 'http';
                        window.BASEURL = 'https://www.135editor.com';
                        var appkey = '5acb2312-79d8-46c1-a7e8-327279291994';
                        angular.extend(editorToolBar, {
                            style_url: isHttps + '://www.135editor.com/editor_styles/open?inajax=1&v=page&appkey=' + appkey,
                            style_width: 360,
                            appkey: appkey,
                            zIndex: 1001,
                            plat_host: 'www.135editor.com',
                            page_url: isHttps + '://www.135editor.com/editor_styles/open_styles?inajax=1&appkey=' + appkey,
                            pageLoad: true,
                            open_editor: true,
                            autoHeightEnabled: false,
                            autoFloatEnabled: true,
                        });
                        initEditorBtns();
                        editorToolBar.toolbars[0].push('spechars', 'button2', 'button3', '插入图片', '云平台组件');
                        ue = window.current_editor = UE.getEditor('ueditor', editorToolBar);
                        ue.setOpt(editorToolBar);
                        editorPlugings();
                        ue.ready(function() {
                            scope.list.HTMLCONTENT = scope.list.HTMLCONTENT.replace(
                                /<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g,
                                '<hr ispageseparator="true"/>'
                            ); // 替换分页符标签，用于编辑器展示
                            ue.setContent(scope.list.HTMLCONTENT);
                            // 纯文本正文及字数
                            var preContent = ue.getContent().replace(/\n/g, '');
                            var dom = document.createElement('div');
                            dom.innerHTML = preContent;
                            preContent = dom.innerText.replace(/\u00a0/g, ' ');
                            scope.list.DOCWORDSCOUNT = preContent
                                .replace(/\n/g, '')
                                .replace(/\u0020/g, '')
                                .replace(/\u3000/g, '').length; // 兼容大数据取稿字数算法不同问题
                            ue.getOpt('lang');
                            if (scope.compareVersion == 'false') {
                                scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                            } else {
                                ueditorService.compareLocalAndServe(scope, scope.type).then(function() {
                                    scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                                });
                            }
                            // 监控metadataid变化，并将正文更新进入本地版本
                            ueditorService.watchMetadataidAndUpdateLocalVersion(scope, scope.type);
                            ue.addListener('contentChange', function() {
                                // 实时双向绑定开始
                                // 编辑器的必填提示
                                $timeout(function() {
                                    var content = ue.getContent();
                                    if (content !== '') {
                                        scope.hasContent = true;
                                    } else {
                                        scope.hasContent = false;
                                    }
                                });
                            });
                            // 显示选中区域的字数
                            ue.addListener('selectionchange', function() {
                                // 查看痕迹后或进入源码模式下禁用编辑器按钮
                                if (this.body.contentEditable === 'false' || this.sourceMode === true) {
                                    for (var k in ueditorBtn) {
                                        if (ueditorBtn[k] !== '') {
                                            ueditorBtn[k].addState('disabled');
                                        }
                                    }
                                } else {
                                    for (var j in ueditorBtn) {
                                        if (ueditorBtn[j] !== '') {
                                            ueditorBtn[j].removeState('disabled');
                                        }
                                    }
                                }
                                var selectionStr = this.selection.getText();
                                var selectionDomArray = this.selection._cachedStartElementPath; // app新增组件，禁止互相插入内部
                                if (selectionDomArray === null) {
                                    return;
                                }
                                scope.insertDisable = (function() {
                                    var flag = false;
                                    for (var i = 0; i < selectionDomArray.length; i++) {
                                        var dom = selectionDomArray[i];
                                        if (dom.getAttribute('class') === 'wg wgVote' || dom.tagName.toLowerCase() === 'blockquote') {
                                            flag = true;
                                            break;
                                        }
                                    }
                                    return flag;
                                })();
                            });
                            deffer.resolve();
                        });
                    });
                    return deffer.promise;
                }

                /**
                 * [editorPlugings description] 编辑器功能扩展
                 * @return {[type]} [description]
                 */
                function editorPlugings() {
                    domUtils = baidu.editor.dom.domUtils;
                    ueditorPlugIn.pictureToolbar(ue, scope, domUtils); // 编辑器中图片工具条
                    ueditorPlugIn.videoPlayer(ue, scope); // 点击播放的视频
                    ueditorPlugIn.videoToolbar_(ue); // 编辑器中的视频工具条
                    // 重写全屏方法
                    ueditorService.rewriteFullScreen(UE, 60);

                    /**
                     * [componentsEnter methodname]组件内部的回车换行处理
                     * @return {[type]} [description] null
                     */
                    ue.setContentOrg = ue.setContent; // 重写百度编辑器的setContent方法，初始化时，禁用官员标签的链接和编辑功能
                    ue.setContent = function(html, isAppendTo, notFireSelectionchange) {
                        var dom = document.createElement('div');
                        dom.innerHTML = html;
                        $(dom)
                            .find("a[class='wgLink']")
                            .each(function(index) {
                                $(this).attr('onclick', 'return false');
                                $(this).attr('contenteditable', 'false');
                            });
                        html = dom.innerHTML;
                        ue.setContentOrg(html, isAppendTo, notFireSelectionchange);
                    };
                    ue.getContentOrg = ue.getContent; // 重写百度编辑器的getContent方法，提交正文时，启用官员标签的链接和编辑功能
                    ue.getContent = function() {
                        var htmlContent = ue.getContentOrg();
                        var dom = document.createElement('div');
                        dom.innerHTML = htmlContent;
                        $(dom)
                            .find("a[class='wgLink']")
                            .each(function() {
                                $(this).removeAttr('onclick');
                                $(this).removeAttr('contenteditable');
                            });
                        return dom.innerHTML;
                    };
                    ueditorForAppService.componentEnter(ue, scope); // 组件中的回车事件
                    ueditorForAppService.componentDelete(ue); // 图片组件中，选中图片后按删除按键，直接删除整个组件
                    ueditorForAppService.supplementaryBlank(ue); // 组件之后自动补充空行
                    ueditorForAppService.deleteComponent(ue); // 删除组件
                    var moveTimeout;
                    ue.addListener('contentchange', function() {
                        ueditorForAppService.dragAndDrop(ue, 'blockquote', moveTimeout);
                    });
                }

                /**
                 * [initEditorBtns description] 附件功能按钮
                 * @return {[type]} [description]
                 */
                function initEditorBtns() {
                    // 暴露在编辑器中的按钮数组
                    ueditorBtn = [];
                    // 遍历按钮方法，实例化按钮，并返回按钮对象
                    for (var i in ueditorForAppBtnService) {
                        ueditorForAppBtnService[i](UE, scope, ue, i).then(function(btn) {
                            ueditorBtn[btn.index] = btn.obj;
                        });
                    }
                }

                /**
                 * [localcache methodname]本地保存
                 * @return {[type]} [description] null
                 */
                function localcache() {
                    ueditorService.saveToLocal(scope.list.METADATAID, scope.type, ue.getContent(), scope.versionid);
                }

                /**
                 * [initDestroy description] 初始化
                 * @return {[type]} [description]
                 */
                function initDestroy() {
                    scope.$on('$destroy', function() {
                        ueditorService.saveContent(scope.list);
                        $interval.cancel(scope.promise); // 销毁定时事件
                        ueditorService.destroyCommonUe(window.current_editor);
                    });
                }
            },
        };
    },
]);
